import { FtpUploadLog } from '@/common/model/fileUpload'
import { MasterType } from '@/common/model/master/w2Master'

export const UploadApiPath = {
  UPLOAD_CSV_BY_TENANT: '/api/tenant/{tenant_id}/upload/{master_type}', // POST Upload Csv By Tenant
  UPLOAD_CSV_MANUAL: '/api/sites/{site_id}/upload/manual', // POST Upload Csv Manual
  LIST_UPLOAD_LOGS: '/api/sites/{site_id}/upload-logs', // GET List Upload Logs
  GET_UPLOAD_LOG: '/api/sites/{site_id}/upload-logs/{log_id}', // GET Upload Log detail (error_details付き)
  RETRY_UPLOAD: '/api/sites/{site_id}/upload-logs/{log_id}/retry' // POST Retry Upload
}

export type UploadApiPath = (typeof UploadApiPath)[keyof typeof UploadApiPath]

export interface UploadCsvByTenantVars {
  tenant_id: string
  master_type: MasterType
  file: string
}

export interface UploadCsvManualVars {
  site_id: number
  master_type: MasterType
  file: string
}

export interface ListUploadLogsVars {
  site_id: number
  page?: number
  per_page?: number
  status?: string | null
  master_type?: string | null
}

export interface RetryUploadVars {
  site_id: number
  log_id: number
}

export interface GetUploadLogVars {
  site_id: number
  log_id: number
}

export interface UploadLog extends FtpUploadLog {
  // 一覧(LIST_UPLOAD_LOGS)では error_details を返さない（GET_UPLOAD_LOG で取得する）ため optional。
  error_details?: { row: number; message: string }[]
  processed_rows: number
}

export type UploadCsvByTenantResponse = UploadLog
export type UploadCsvManualResponse = UploadLog

export interface ListUploadLogsResponse {
  total: number
  page: number
  per_page: number
  logs: UploadLog[]
}

export type RetryUploadResponse = UploadLog
export type GetUploadLogResponse = UploadLog
